/**
 * @file Conteneur des services metier du core (instancies une fois par Simulation, partagent le SimContext).
 */
import type { SimContext } from '../Context';
import { AmmoSkinService } from './AmmoSkinService';
import { AuraService } from './AuraService';
import { FireworkService } from './FireworkService';
import { HubService } from './HubService';
import { BuffService } from './BuffService';
import { CollectiblesService } from './CollectiblesService';
import { MissionService } from './MissionService';
import { OfflineService } from './OfflineService';
import { DailyService, PassService, TicketService, TutorialService, UnlockService } from './ProgressionServices';
import { RebirthService } from './RebirthService';
import { ShotFxService } from './ShotFxService';
import { SkinService } from './SkinService';
import { StarService } from './StarService';
import { TeamService } from './TeamService';
import { UpgradeService } from './UpgradeService';
import { WeaponService } from './WeaponService';

export interface Services {
  upgrades: UpgradeService;
  weapons: WeaponService;
  stars: StarService;
  skins: SkinService;
  ammoSkins: AmmoSkinService;
  auras: AuraService;
  fireworks: FireworkService;
  shotFx: ShotFxService;
  hub: HubService;
  buffs: BuffService;
  rebirth: RebirthService;
  offline: OfflineService;
  missions: MissionService;
  pass: PassService;
  daily: DailyService;
  tickets: TicketService;
  unlocks: UnlockService;
  tutorial: TutorialService;
  team: TeamService;
  collectibles: CollectiblesService;
}

export const createServices = (ctx: SimContext): Services => ({
  upgrades: new UpgradeService(ctx),
  weapons: new WeaponService(ctx),
  stars: new StarService(ctx),
  skins: new SkinService(ctx),
  ammoSkins: new AmmoSkinService(ctx),
  auras: new AuraService(ctx),
  fireworks: new FireworkService(ctx),
  shotFx: new ShotFxService(ctx),
  hub: new HubService(ctx),
  buffs: new BuffService(ctx),
  rebirth: new RebirthService(ctx),
  offline: new OfflineService(ctx),
  missions: new MissionService(ctx),
  pass: new PassService(ctx),
  daily: new DailyService(ctx),
  tickets: new TicketService(ctx),
  unlocks: new UnlockService(ctx),
  tutorial: new TutorialService(ctx),
  team: new TeamService(ctx),
  collectibles: new CollectiblesService(ctx),
});

export {
  AmmoSkinService,
  AuraService,
  FireworkService,
  HubService,
  ShotFxService,
  BuffService,
  CollectiblesService,
  DailyService,
  MissionService,
  OfflineService,
  PassService,
  RebirthService,
  SkinService,
  StarService,
  TeamService,
  TicketService,
  TutorialService,
  UnlockService,
  UpgradeService,
  WeaponService,
};
